import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Card from "../components/Card";
import axios from "axios";
import { publicRequest, userRequest } from "../requestMethods";
import { useSelector } from "react-redux";

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const Home = ({ type }) => {
  const [videos, setVideos] = useState([]);
  const { currentUser } = useSelector((state) => state.user);

  useEffect(() => {
    const fetchVideos = async () => {
      const res = currentUser
        ? await userRequest.get(`/videos/${type}`)
        : await publicRequest.get(`/videos/${type}`);
      setVideos(res?.data);
    };
    fetchVideos();
  }, [type]);

  return (
    <Container>
      {videos?.map((video) => (
        <Card key={video?._id} video={video} />
      ))}
    </Container>
  );
};

export default Home;
